import React, { useState, useEffect } from 'react'
import Image from 'next/image'
import styles from './styles.module.scss'
import { useRouter } from 'next/router'

export const CategorieIcons = ({ listIconsData, onCategorySelect }) => {
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(null)
  const [isHovering, setIsHovering] = useState(false)
  const router = useRouter()
  const { query } = router

  useEffect(() => {
    const handleDocumentScroll = event => {
      if (isHovering) {
        event.preventDefault()
      }
    }

    document.addEventListener('wheel', handleDocumentScroll, {
      passive: false,
    })

    return () => {
      document.removeEventListener('wheel', handleDocumentScroll)
    }
  }, [isHovering])

  const handleCategoryClick = (index, iconData) => {
    if (activeCategoryIndex === index) {
      onCategorySelect(
        listIconsData.map(icon => icon.attributes.lists.data).flat()
      )
      setActiveCategoryIndex(null)
      router.push({ query: { ...query, page: undefined } }, undefined, {
        shallow: true,
      })
    } else {
      onCategorySelect(iconData.attributes.lists.data)
      setActiveCategoryIndex(index)
      router.push(
        { query: { ...query, page: iconData.attributes.title } },
        undefined,
        { shallow: true }
      )
    }
  }

  const handleScroll = event => {
    if (!isHovering) return

    const container = event.target
    const scrollDirection = event.deltaY > 0 ? 'right' : 'left'

    if (scrollDirection === 'right') {
      container.scrollLeft += 30
    } else {
      container.scrollLeft -= 30
    }
  }

  return (
    <div
      className={styles.categories}
      onWheel={handleScroll}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <div className={styles.categories__container}>
        {listIconsData?.map((iconData, index) => (
          <div
            key={index}
            className={`${styles.categories__icon} ${
              activeCategoryIndex === index ? styles.activeCategory : ''
            }`}
            onClick={() => handleCategoryClick(index, iconData)}
          >
            <div className={styles.imgContainer}>
              <Image
                className={styles.categories__image}
                src={iconData.attributes.image?.data?.attributes.url}
                alt='list-icon'
                width={48}
                height={48}
                placeholder='blur'
                blurDataURL={
                  iconData.attributes.image?.data?.attributes.url || ''
                }
              />
            </div>
            <div className={styles.categories__title}>
              {iconData.attributes.title}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
